applyOptions